<template>
  <v-layout row wrap justify-center>
    <v-flex xs12 sm10 md10>
      <v-layout row wrap>
          <v-flex xm12 md4 class="title">
            <v-btn fab outline small value="email" color="primary" :to="{ path: '/committees/' + $route.params.committee + '/' + currentYear}">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xm12 md4 class="text-sm-center">
            <span class="headline">{{ $route.params.committee }} SCHEDULE</span><br />
          </v-flex>
          <v-flex xm12 md4 class="title text-sm-right">
            <v-tooltip bottom>
              <v-btn fab outline small value="export" color="primary" slot="activator" @click="getPrefList()">
                <v-icon>mdi-account</v-icon>
              </v-btn>
              <span>Preferred List</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn fab outline small value="export" color="primary" slot="activator" @click="onExport()">
                <v-icon>cloud_download</v-icon>
              </v-btn>
              <span>Export Schedule</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn fab outline small value="export" color="primary" slot="activator" @click="onUpload()">
                <v-icon>cloud_upload</v-icon>
              </v-btn>
              <span>Upload Schedule</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn fab outline small value="email" color="primary" slot="activator" @click="emailAll()">
                <v-icon>email</v-icon>
              </v-btn>
              <span>Email Participants</span>
            </v-tooltip>
          </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            v-for="schedule in schedules"
            :key="schedule.id"
            xs12
          >
            <v-toolbar color="blue" dark>
              <v-toolbar-title>{{ schedule.Name }}</v-toolbar-title>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex
                    v-for="scheduleDay in schedule.ScheduleDays"
                    :key="scheduleDay.id"
                    xs12 md4 lg3
                  >
                    <v-card color="blue lighten-5">
                      <v-card-title primary-title class="blue--text">
                        <div color="primary" class="title">{{ scheduleDay.formatDate }}</div>
                      </v-card-title>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex
                            v-for="schedule in scheduleDay.Schedules"
                            :key="schedule.id"
                            xs12
                          >
                            <v-card>
                              <v-card-title primary-title>
                                <v-list-tile-title class="title">{{ schedule.name }}</v-list-tile-title>
                                <v-list-tile-sub-title class="subheading">{{ schedule.start }} - {{ schedule.end }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title class="subheading">({{ schedule.quantity }} people required)</v-list-tile-sub-title>
                                <div class="body-2">{{ schedule.notes }}</div>
                              </v-card-title>

                              <v-card-text>
                                <div class="subheading">Members</div>

                                <v-list dense>
                                  <v-list-tile
                                    v-for="item in schedule.Users"
                                    :key="item.id"
                                  >
                                    <v-list-tile-content>
                                      <v-list-tile-title>{{ item.fullName }} ({{ item.UserSchedule.status }})</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                      <v-btn flat icon color="pink" @click="deleteMember(schedule.id, item.id)">
                                        <v-icon>delete</v-icon>
                                      </v-btn>
                                    </v-list-tile-action>
                                  </v-list-tile>
                                </v-list>
                              </v-card-text>

                              <v-card-actions>
                                <v-autocomplete
                                  :items="memberList"
                                  item-text="fullName"
                                  item-value="id"
                                  v-model="schedule.userId"
                                  label="Members"
                                  hide-details
                                  @change="saveMember(schedule)"
                                ></v-autocomplete>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="onExportSched(schedule.id)">
                                  <v-icon>cloud_download</v-icon>
                                </v-btn>
                                <v-btn v-if="schedule.emails.length > 0" icon @click="emailTeam(schedule.emails)">
                                  <v-icon>email</v-icon>
                                </v-btn>
                                <v-btn icon @click="editSchedule(schedule)">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="addNew()"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog1" max-width="500px" persistent>
      <v-card >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeThis">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Preferred List</v-toolbar-title>
        </v-toolbar>

        <v-list subheader>
          <v-list-tile
            v-for="item in prefList"
            :key="item.id"
            avatar
          >

            <v-list-tile-content>
              <v-list-tile-title>{{ item.lastName }}, {{ item.firstName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.title }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile @click.stop="deletePref(item.id)">
              <v-list-tile-action>
                <v-icon color="red">delete</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="1000px" persistent>
    <v-card >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeThis">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Add/Edit Schedule</v-toolbar-title>
      </v-toolbar>

      <v-form
          ref="form"
          v-model="valid"
          lazy-validation
      >
      <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formattedDate"
                    label="Date"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    @change="editedItem.date = parseDate(formattedDate)"
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="editedItem.date"
                    no-title
                    @input="menu1 = false"
                    @change="formattedDate = formatDate(editedItem.date)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  :items="theTimes"
                  v-model="editedItem.startTime"
                  label="Start Time"
                  prepend-icon="access_time"
                ></v-select>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  :items="theTimes"
                  v-model="editedItem.endTime"
                  label="End Time"
                  prepend-icon="access_time"
                ></v-select>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="editedItem.quantity"
                  label="No of people required"
                  required
                  mask="###"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  :items="access"
                  v-model="editedItem.status"
                  menu-props="auto"
                  label="Schedule Access"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="!editedItem.id">
                <v-select
                  :items="occurs"
                  v-model="editedItem.reoccur"
                  label="Repeat how many days?"
                  small
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.notes"
                  label="Notes"
                  prepend-icon="notes"
                  required
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        <v-alert :value="error" type="warning" transition="scale-transition">
          <span v-html="error"></span>
        </v-alert>

      </v-card-text>
      <v-card-actions>
        <v-btn v-if="editedItem.id > 0" color="error" @click="deleteSchedule(editedItem.id)">Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-form>
    </v-card>
  </v-dialog>

    <v-dialog
      v-model="dialog2"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="closeThis">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Upload Schedule</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-btn
                  color="blue-grey"
                  class="white--text"
                  @click="getUpload()"
                >
                  Download Start File
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Select..."
                  @click='onPickFile'
                  v-model='editDocument.fileName'
                  prepend-icon="attach_file"
                ></v-text-field>
                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="*/*"
                  @change="onFilePicked($event)">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'
import EmailForm from '../forms/EmailForm'
import XLSX from 'xlsx'

export default {
  components: {
    EmailForm
  },
  data () {
    return {
      menu1: false,
      formattedDate: '',
      showEmailForm: false,
      valid: true,
      dialog: false,
      dialog1: false,
      dialog2: false,
      error: '',
      currentYear: 0,
      saving: false,
      statuses: ['Pending', 'Active'],
      access: [
        { text: 'Preferred', value: 'Preferred' },
        { text: 'Everyone', value: 'Everyone' }
      ],
      occurs: [1, 2, 3, 4, 5],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedItem: {
        reoccur: 1
      },
      userId: '',
      editDocument: {},
      parse_csv: [],
      titleName: '',
      config: {},
      schedules: [],
      schedules1: [],
      printSchedules: [],
      emails: [],
      allEmails: [],
      emailList: [],
      memberList: [],
      prefList: [],
      theTimes: [
        '6:00 am',
        '6:15 am',
        '6:30 am',
        '6:45 am',
        '7:00 am',
        '7:15 am',
        '7:30 am',
        '7:45 am',
        '8:00 am',
        '8:15 am',
        '8:30 am',
        '8:45 am',
        '9:00 am',
        '9:15 am',
        '9:30 am',
        '9:45 am',
        '10:00 am',
        '10:15 am',
        '10:30 am',
        '10:45 am',
        '11:00 am',
        '11:15 am',
        '11:30 am',
        '11:45 am',
        '12:00 pm',
        '12:15 pm',
        '12:30 pm',
        '12:45 pm',
        '1:00 pm',
        '1:15 pm',
        '1:30 pm',
        '1:45 pm',
        '2:00 pm',
        '2:15 pm',
        '2:30 pm',
        '2:45 pm',
        '3:00 pm',
        '3:15 pm',
        '3:30 pm',
        '3:45 pm',
        '4:00 pm',
        '4:15 pm',
        '4:30 pm',
        '4:45 pm',
        '5:00 pm',
        '5:15 pm',
        '5:30 pm',
        '5:45 pm',
        '6:00 pm',
        '6:15 pm',
        '6:30 pm',
        '6:45 pm',
        '7:00 pm',
        '7:15 pm',
        '7:30 pm',
        '7:45 pm',
        '8:00 pm',
        '8:15 pm',
        '8:30 pm',
        '8:45 pm',
        '9:00 pm',
        '9:15 pm',
        '9:30 pm',
        '9:45 pm',
        '10:00 pm',
        '10:15 pm',
        '10:30 pm',
        '10:45 pm',
        '11:00 pm',
        '11:15 pm',
        '11:30 pm',
        '11:45 pm',
        '12:00 am',
        '12:15 am',
        '12:30 am',
        '12:45 am',
        '1:00 am',
        '1:15 am',
        '1:30 am',
        '1:45 am',
        '2:00 am',
        '2:15 am',
        '2:30 am',
        '2:45 am',
        '3:00 am',
        '3:15 am',
        '3:30 am',
        '3:45 am',
        '4:00 am',
        '4:15 am',
        '4:30 am',
        '4:45 am',
        '5:00 am',
        '5:15 am',
        '5:30 am',
        '5:45 am'
      ]
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name
    this.currentYear = this.$store.state.currentYear
    this.getSchedule()
    this.getMembers()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    addNew () {
      this.editedItem.reoccur = 1
      this.dialog = true
    },

    emailTeam (email) {
      this.emails = email
      this.emailList = email
      this.showEmailForm = true
    },

    emailAll () {
      this.emails = this.allEmails
      this.emailList = this.allEmails
      this.showEmailForm = true
    },

    editSchedule (schedule) {
      this.editedItem = schedule
      // this.editedItem.date = this.editedItem.formatDate
      this.editedItem.startTime = this.editedItem.start
      this.editedItem.endTime = this.editedItem.end
      this.formattedDate = moment(this.editedItem.date).format('MM/DD/YYYY')
      this.dialog = true
    },

    loadItem () {
      this.editedItem = this.item

      this.formattedDate = moment(this.editedItem.date).format('MM/DD/YYYY')
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async getSchedule () {
      try {
        let allEmails = []
        let schedules = []
        // let printSchedules = []
        let push = false

        const response = await Api().get('/comm_schedules/' + this.$route.params.committeeId)
        // console.log(response.data)

        this.schedules = response.data

        for (let i in this.schedules) {
          for (let j in this.schedules[i].ScheduleDays) {
            const [year, month, day] = this.schedules[i].ScheduleDays[j].Num.split('-')
            this.schedules[i].ScheduleDays[j].formatDate = `${month}/${day}/${year}`

            for (let k in this.schedules[i].ScheduleDays[j].Schedules) {
              this.schedules[i].ScheduleDays[j].Schedules[k].start = moment(this.schedules[i].ScheduleDays[j].Schedules[k].startTime, 'HH:mm').format('h:mm a')
              this.schedules[i].ScheduleDays[j].Schedules[k].end = moment(this.schedules[i].ScheduleDays[j].Schedules[k].endTime, 'HH:mm').format('h:mm a')
              this.schedules[i].ScheduleDays[j].Schedules[k].userId = ''

              this.schedules[i].ScheduleDays[j].Schedules[k].emails = []

              let users = this.schedules[i].ScheduleDays[j].Schedules[k].Users

              if (users.length > 0) {
                let emails = []
                for (let j in users) {
                  emails.push(users[j].email)
                  allEmails.push(users[j].email)
                }
                this.schedules[i].ScheduleDays[j].Schedules[k].emails = emails
              }

              push = true
            }
          }

          if (push) {
            schedules.push(this.schedules[i])
          }
          push = false
        }
        console.log(schedules)
        schedules = schedules.sort((a, b) => a.Num - b.Num)

        this.schedules = schedules
        this.allEmails = Array.from(new Set(allEmails))

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getPrefList () {
      try {
        const response = await Api().get('/get_preferred/' + this.$route.params.committeeId)
        this.prefList = response.data

        this.dialog1 = true
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async onUpload () {
      try {
        this.dialog2 = true
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    onPickFile () {
      this.$refs.fileInput.click()
    },

    onFilePicked (event) {
      let innerText = ''
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.addEventListener('load', () => {
        // this will then display a text file
        innerText = reader.result
      })

      if (file) {
        reader.readAsText(file)
        console.log('ran')
      }
      console.log('text', innerText)
    },

    csvJSON (csv) {
      const vm = this
      const lines = csv.split(/\r?\n/)
      const result = []

      lines.map(function (line, indexLine) {
        if (indexLine < 1 && vm.header === true) return // Jump header line

        const obj = {}
        line = line.replace('\r', '')
        const currentline = line.split(',')

        vm.parse_header.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader]
        })

        result.push(obj)
      })

      return result // JavaScript object
    },

    async deletePref (id) {
      try {
        let editedCommittee = {}
        editedCommittee.userId = id
        editedCommittee.committeeId = this.$route.params.committeeId
        editedCommittee.status = 'inactive'
        console.log(editedCommittee)
        const response = await Api().put('user_committees_end', editedCommittee)

        this.getPrefList()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveMember (schedule) {
      try {
        schedule.scheduleId = schedule.id
        schedule.status = 'Yes'

        const response = await Api().post('member_schedules/', schedule)

        this.getSchedule()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteMember (scheduleId, userId) {
      try {
        const response = await Api().delete('member_schedules/' + scheduleId + '/' + userId)

        this.getSchedule()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async printForm (date) {
      try {
        await Api().post('get_pdf/' + this.editedItem.id, this.editedItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/' + this.editedItem.id + 'app.pdf', '_blank')

          // console.log(route)
          console.log(response)
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.id > 0) {
          // console.log('Update')
          this.updateItem(this.editedItem)
        } else {
          // console.log('Save')
          this.addItem(this.editedItem)
        }
      } else {
        this.snackbar.message = 'You have some errors on the page!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addItem () {
      try {
        this.editedItem.CommitteeId = this.$route.params.committeeId

        this.editedItem.month = moment(this.editedItem.date).format('MMMM')
        this.editedItem.monthNo = moment(this.editedItem.date).format('MM')
        this.editedItem.year = moment(this.editedItem.date).format('YYYY')
        this.editedItem.startTime = moment(this.editedItem.startTime, 'h:mm a').format('HH:mm')
        this.editedItem.endTime = moment(this.editedItem.endTime, 'h:mm a').format('HH:mm')

        const response = await Api().post('comm_schedules/', this.editedItem)
        console.log('test', response)
        this.message = response.data.message
        this.getSchedule()
        this.editedItem = {}
        this.formattedDate = ''

        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        this.editedItem.CommitteeId = this.$route.params.committeeId
        // const [month, day, year] = this.editedItem.date.split('/')
        // this.editedItem.date = `${year}-${month}-${day}`

        this.editedItem.month = moment(this.editedItem.date).format('MMMM')
        this.editedItem.monthNo = moment(this.editedItem.date).format('MM')
        this.editedItem.year = moment(this.editedItem.date).format('YYYY')
        this.editedItem.startTime = moment(this.editedItem.startTime, 'h:mm a').format('HH:mm')
        this.editedItem.endTime = moment(this.editedItem.endTime, 'h:mm a').format('HH:mm')

        const response = await Api().put('comm_schedules/' + this.editedItem.id, this.editedItem)
        this.getSchedule()
        this.editedItem = {}
        this.formattedDate = ''

        this.dialog = false

        this.message = response.data.message
        this.show = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteSchedule (scheduleId) {
      console.log(scheduleId)
      let r = confirm('Are you sure you want to delete this Schedule?')

      if (r === true) {
        try {
          const response = await Api().delete('comm_schedules/' + scheduleId)

          this.getSchedule()
          this.editedItem = {}
          this.formattedDate = ''

          this.dialog = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async onExport () {
      try {
        const response = await Api().get('comm_report/' + this.$route.params.committeeId + '/' + this.currentYear)

        const schedule = response.data
        console.log('rows', schedule)
        let printArray = []
        let printItem = {}

        for (let i in schedule) {
          let stime = '2026-01-01 ' + schedule[i].startTime + ':00'
          let date = moment(schedule[i].date).format('MM/DD/YYYY')
          let time = moment(stime).format('h:mm a')

          printItem['Committee'] = schedule[i].commName
          printItem['Year'] = schedule[i].year
          printItem['Schedule'] = schedule[i].schedname
          printItem['Date'] = date
          printItem['Time'] = time
          printItem['Notes'] = schedule[i].notes
          printItem['Name'] = schedule[i].lastName + ', ' + schedule[i].firstName
          printItem['Email'] = schedule[i].email
          printItem['Address'] = schedule[i].address1
          printItem['City'] = schedule[i].city
          printItem['State'] = schedule[i].state
          printItem['Zip'] = schedule[i].zip
          printItem['Mobile'] = schedule[i].cellPhone

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Schedule Report'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Schedule Report')

        XLSX.writeFile(wb, 'schedule_report.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportSched (id) {
      try {
        const response = await Api().get('sched_report/' + id + '/' + this.currentYear)

        const schedule = response.data
        console.log('rows', schedule)
        let printArray = []
        let printItem = {}

        for (let i in schedule) {
          let stime = '2026-01-01 ' + schedule[i].startTime + ':00'
          let date = moment(schedule[i].date).format('MM/DD/YYYY')
          let time = moment(stime).format('h:mm a')

          printItem['Committee'] = schedule[i].commName
          printItem['Year'] = schedule[i].year
          printItem['Schedule'] = schedule[i].schedname
          printItem['Date'] = date
          printItem['Time'] = time
          printItem['Notes'] = schedule[i].notes
          printItem['Name'] = schedule[i].lastName + ', ' + schedule[i].firstName
          printItem['Email'] = schedule[i].email
          printItem['Address'] = schedule[i].address1
          printItem['City'] = schedule[i].city
          printItem['State'] = schedule[i].state
          printItem['Zip'] = schedule[i].zip
          printItem['Mobile'] = schedule[i].cellPhone

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Schedule Report'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Schedule Report')

        XLSX.writeFile(wb, 'schedule_report.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    getUpload () {
      let printArray = []
      let printItem = {}

      printItem['Name'] = 'Sample Title'
      printItem['Date'] = '07/01/2026'
      printItem['Start Time'] = '05:30 PM'
      printItem['End Time'] = '07:30 PM'
      printItem['Notes'] = 'Add Notes Here'
      printItem['No of People'] = '5'
      printItem['Committee ID'] = this.$route.params.committeeId

      printArray.push(printItem)
      printItem = {}
      console.log(printItem)

      let membersWS = XLSX.utils.json_to_sheet(printArray)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Sample Upload'

      XLSX.utils.book_append_sheet(wb, membersWS, 'Sample Upload')

      XLSX.writeFile(wb, 'sample_upload.xlsx')
    },

    closeThis () {
      this.editedItem = {}
      this.formattedDate = ''
      this.dialog = false
      this.dialog1 = false
      this.dialog2 = false
      this.showEmailForm = false
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/List.vue